<template>
    <div class="loader">
        <svg class="loader__image active" fill="currentColor" height="267.1700134277344"
             viewBox="0 0 407.43 267.17"
             width="407.42999267578125" xmlns="http://www.w3.org/2000/svg">
            <path class="image__cloud"
                  d="M120.15,213s-122,40-117-80c0-2,0-77,104-73,0-1,46-70,125-39,2,1,89-62.62,159,43.69,2,3.31,39,63.31-20,128.31,0,0-52,50-105,32C269.15,228,186.15,319,120.15,213Z"></path>
            <path
                class="image__d"
                d="M75.12,107.54h9.64v51.12H75.12ZM80,149.37H92.24q4.76,0,7.35-2.28a8.13,8.13,0,0,0,2.6-6.47V125.57a8.14,8.14,0,0,0-2.6-6.47q-2.59-2.28-7.35-2.28H80v-9.28H92A25.29,25.29,0,0,1,103,109.68a15.22,15.22,0,0,1,6.87,6.26,19.64,19.64,0,0,1,2.36,9.91v14.49a19.64,19.64,0,0,1-2.27,9.63,15.47,15.47,0,0,1-6.8,6.4A24.58,24.58,0,0,1,92,158.66H80Z"></path>
            <path
                class="image__r"
                d="M128.87,107.5h9.63v51.16h-9.63Zm3.83,21.31h17.79a4.66,4.66,0,0,0,2.6-.74,4.8,4.8,0,0,0,1.74-2.11,8,8,0,0,0,.65-3.16,7.7,7.7,0,0,0-.61-3.17,4.8,4.8,0,0,0-1.74-2.11,4.72,4.72,0,0,0-2.64-.74H132.7V107.5h18.56a14.3,14.3,0,0,1,7.42,1.9,12.86,12.86,0,0,1,5,5.36,19.22,19.22,0,0,1,0,16.07,12.78,12.78,0,0,1-5,5.36,14.23,14.23,0,0,1-7.4,1.9H132.7Zm10.76,7.7,10.3-1.62,13.78,23.77H155.87Z"></path>
            <path
                class="image__e"
                d="M183,107.54h9.64v51.12H183Zm3.48,0h30.76v9.28H186.48Zm0,21.09h26.9v9.28h-26.9Zm0,20.74h30.76v9.29H186.48Z"></path>
            <path
                class="image__a"
                d="M247.86,107.54H254l19.54,51.12H263.15l-12.23-34.91-12.24,34.91H228.31ZM237.7,141.18h26.89v9.28H237.7Z"></path>
            <path
                class="image__m"
                d="M319.22,107.54h12.69v51.12h-8.75V119l.35,2.25L313.73,153h-8.5l-9.78-31,.35-3v39.7h-8.75V107.54h12.69L309.48,142Z"></path>
        </svg>
    </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@import "../assets/scss/variables";

.loader {

    color: white;

    &__image {
        width: 100%;
        margin: 0 auto;
        height: auto;
    }
}

@keyframes animate-svg-stroke {
    0% {
        stroke-dashoffset: 1080.6998291015625px;
        stroke-dasharray: 1080.6998291015625px;
        stroke-opacity: 1;
    }

    70% {
        stroke-dashoffset: 0;
        stroke-dasharray: 1080.6998291015625px;
        stroke-opacity: 1;
        stroke: $primary;
    }

    100% {
        stroke-opacity: 0;
    }
}


@keyframes animate-svg-fill {
    0%, 100% {
        fill-opacity: 0;
    }
    50% {
        fill-opacity: 1;
    }
}

.image__cloud {
    fill: transparent;
    stroke: #FFFFFF;
    stroke-miterlimit: 10;
    stroke-width: 6px;
    stroke-opacity: 0;
    animation: animate-svg-stroke 3s cubic-bezier(0.47, 0, 0.745, 0.715) infinite;
}

.image__d, .image__r, .image__e, .image__a, .image__m {
    fill-opacity: 0;
    animation-name: animate-svg-fill;
    animation-iteration-count: infinite;
    animation-duration: 3s;
    animation-timing-function: cubic-bezier(0.47, 0, 0.745, 0.715);
    animation-delay: 0.9s;
}

.image__r {
    animation-delay: 1s;
}

.image__e {
    animation-delay: 1.1s;
}

.image__a {
    animation-delay: 1.2s;
}

.image__m {
    animation-delay: 1.3s;
}

</style>
